<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-form ref="filterForm">
            <div slot="body">
              <div class="row">
                <bita-select
                  name="status"
                  ref="status"
                  label="وضعیت"
                  validation-container-class="col-lg-3"
                  input-class="form-control"
                  :data-source="statuses"
                  data-text-field="title"
                  data-value-field="id"
                  v-model="filters.status"
                />
                <bita-select
                  name="commentable_type"
                  ref="commentabletype"
                  label="جایگاه"
                  validation-container-class="col-lg-3"
                  input-class="form-control"
                  :data-source="commentableTypes"
                  data-text-field="name"
                  data-value-field="type"
                  v-model="filters.commentable_type"
                />
                <div class="col-lg-4">
                  <a class="margin-top btn btn-success" @click="loadData()">
                    جستجو
                  </a>
                  <a
                    class="margin-top margin-right btn btn-warning"
                    @click="resetFilters()"
                  >
                    پاک سازی
                  </a>
                </div>
              </div>
            </div>
          </bita-form>
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :page-size="pageSize"
            :current-page="currentPage"
          />
        </div>
      </bita-ibox>
    </div>
    <comment-form
      ref="commentForm"
      id="comment-form"
      title="مشاهده کامنت"
      :props-data="formData"
      :replay-data="replayData"
      :is-loading="isLoadingModal"
      @on-reply="(e) => reply(e)"
      @on-delete="(e) => handleDelete(e)"
    />
  </div>
</template>
<script>
import CommentForm from "./components/CommentForm";
import { commentApi } from "@/api/apiManagement";
export default {
  components: { CommentForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "کامنت ها", link: "/management/comments" },
      ],
      isLoadingGrid: false,
      isLoadingModal: false,
      formData: {},
      replayData: {},
      filters: {},
      pageSize: 30,
      currentPage: 1,
      statuses: [
        {
          id: 0,
          title: "تایید نشده",
        },
        {
          id: 1,
          title: "تایید شده",
        },
      ],
      commentableTypes: [
        {
          type: "product",
          name: "محصول",
        },
        {
          type: "post",
          name: "نوشته",
        },
      ],
      gridColumns: [
        { title: "نام کاربری", template: (e) => (e.user ? e.user.name : "-") },
        {
          field: "status",
          title: "وضعیت",
          template: (e) => (e.status_text ? e.status_text : "-"),
        },
        {
          field: "commentable",
          title: "در پاسخ به",
          template: function(e) {
            if (!e.commentable) return "-";
            else if (e.commentable.name) return e.commentable.name;

            return e.commentable.title;
          },
        },
        {
          field: "commenttable_type_text",
          title: "جایگاه",
          template: (e) =>
            e.commentable_type_text ? e.commentable_type_text : "-",
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
        {
          title: "عملیات",
          command: [],
        },
      ],
    };
  },
  mounted() {
    if (this.$route.query) this.filters = this.$route.query;
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    this.loadData();
  },
  methods: {
    readData(e) {
      this.isLoadingGrid = true;
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      commentApi
        .getComments({
          page_size: this.pageSize,
          page: this.currentPage,
          ...this.filters,
        })
        .then((res) => {
          console.log(res.data.entity);
          e.success(res.data.entity);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.$refs.grid.kendoWidget().dataSource.read();
    },
    viewProduct(e) {
      let comment = this.$refs.grid.getSelectedGridRow(e);
      window.open(comment.commentable.share_url);
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "view",
        click: this.viewProduct,
        template: this.gridButtons.view,
      });
      if (this.$acl.can("create", "comments"))
        commands.push({
          text: "comment",
          click: this.edit,
          template: this.gridButtons.comment,
        });
      commands.push({
        text: "status",
        click: this.status,
        template: this.gridButtons.status,
      });
      if (this.$acl.can("delete", "comments"))
        commands.push({
          text: "delete",
          click: this.delete,
          template: this.gridButtons.delete,
        });
      return commands;
    },
    toggleModal() {
      this.$toggleModal("#comment-form");
    },
    edit(e) {
      let comment = this.$refs.grid.getSelectedGridRow(e);
      this.formData = comment;
      this.isLoadingModal = true;
      this.toggleModal();

      commentApi.getChild(comment.id).then(({ data }) => {
        this.formData = data.entity;
        this.isLoadingModal = false;
      });
    },
    status(e) {
      let comment = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `ایا از تغییر وضعیت این مورد مطمئن هستید`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          commentApi
            .toggleCommentStatus(comment.id)
            .then((res) => {
              this.$izitoast("success", "موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    delete(e) {
      let comment = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف این کامنت اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          commentApi
            .deleteComments(comment.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    handleDelete(e) {
      this.$alert("question", `آیا از حذف این کامنت اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          commentApi
            .deleteComments(e.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.toggleModal();
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    resetFilters() {
      this.filters = {};
    },
    reply(data) {
      this.isLoadingModal = true;
      commentApi
        .replyComment(data.comment_id, { reply: data.reply })
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.$refs.commentForm.reset();
          this.toggleModal();
          this.loadData();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    update(e) {},
  },
};
</script>
